import BordableModel from './BordableModel';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export const getDefaultProps = () => {
    return {
        text: new PropertyDescriptor("", '文本', "文本", "text", "#anticon-text", {
            gallery: "外观",
            placeholder: '请输入文本'
        }),
        fontFamily: new PropertyDescriptor("", '字体', "文本", "font", "#anticon-font", {
            gallery: "外观",
            placeholder: '留空为默认字体或输入字体名称'
        }),
        fontSize: new PropertyDescriptor(18, '大小', "文本", "double", "#anticon-font_size", {
            gallery: "外观",
            minValue: 0,
        }),
        fontColor: new PropertyDescriptor('#333', '颜色', "文本", "color", "#anticon-icon_Fontcolor", {
            gallery: "外观",
        }),
        isBold: new PropertyDescriptor(false, '粗体', "文本", "bool", "#anticon-bold", {
            gallery: "外观",
        }),

        verticalAlignment: new PropertyDescriptor("center", '垂直对齐', "文本", "enum", "#anticon-zhong", {
            gallery: "外观",
            catalogIndex: 30,
            values: [
                new PropertyDescriptor("flex-start", '上', "垂直对齐", "string"),
                new PropertyDescriptor("center", '中', "垂直对齐", "string"),
                new PropertyDescriptor("flex-end", '下', "垂直对齐", "string"),
            ]
        }),
        horizontalAlignment: new PropertyDescriptor("center", '水平对齐', "文本", "enum", "#anticon-shuping", {
            gallery: "外观",
            values: [
                new PropertyDescriptor("flex-start", '左', "垂直对齐", "string"),
                new PropertyDescriptor("center", '中', "垂直对齐", "string"),
                new PropertyDescriptor("flex-end", '右', "垂直对齐", "string"),
            ]
        })
    }
}

export default class TextableModel extends BordableModel {
    constructor() {
        super();
        let defaultProps = getDefaultProps();
        for (let field in defaultProps) {
            this[field] = defaultProps[field];
        }
    }


    toStyle() {


        // return `
        //     ${super.toStyle()}
        //     font-family:${this.fontFamily};
        //     font-size:${this.fontSize};
        //     font-weight:${this.isBold ? 'bold' : 'normal'};
        //     display: flex;
        //     flex-direction: row;
        //     align-items: ${this.verticalAlignment};
        //     justify-content: ${this.horizontalAlignment};
        //     ${super.getExtendStyle()}
        // `;

        return {
            ...super.toStyle(),
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontWeight: this.isBold ? 'bold' : 'normal',
            color: this.fontColor,
            display: 'flex',
            flexDirection: 'row',
            textAlign: this.horizontalAlignment === "center" ? "center" : (this.horizontalAlignment === "flex-start" ? "left" : "right"),
            alignItems: this.verticalAlignment,
            justifyContent: this.horizontalAlignment,
            ...super.getExtendStyle(),
        }
    }
}
